import React from 'react';
import './pages.css'
import { tsParticles } from "tsparticles-engine";
import { loadPolygonPath } from "tsparticles-path-polygon";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SpaIcon from '@mui/icons-material/Spa';
import CodeIcon from '@mui/icons-material/Code';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import ComputerIcon from '@mui/icons-material/Computer';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import "@fontsource/amiri"

function Projects() {
    const projectList = [
      {
        title: 'AI Match Predictor',
        description: ["Created a program using Selenium that fetched 1,000+ unique statistics of teams/players from a webserver", "Invented an algorithm that correlated statistics with likeliness of teams winning any given match","Supplemented the algorithm with self-improving code based on correct/incorrect predictions", "Extensive research of 1,200 unique data points’ correlation to win probability"],
        technologies: ['Python', 'Selenium'],
      },
      {
        title: 'Spa Schedule Web Scraper',
        description: ["Developed a Python web scraper targeting competing spas to identify consumer booking trends and estimate revenue", "Presented database of retrieved information to project the profit potential for the startup"],
        technologies: ['Python', 'Selenium', 'Pandas', 'Excel'],
        github: '',
      },
      {
        title: 'Last Shot Xpresso Mobile App',
        description: ["Designed an appealing front-end application using Swift for iOS devices", "Created an intuitive UI for customers to order coffee products remotely", "Developed back-end Rest API using Python to send order information to the front-end application", "Integrated NCR-Silver point of sale software in the app to process and record orders"],
        technologies: ['Swift'],
      },
      {
        title: 'PyTorch Image Classifier',
        description: ["Engineered a neural network for classifying and identifying images of clothing", "Trained on the FashionMNIST dataset, containing over 60,000 training and test examples"],
        technologies: ['Python', 'PyTorch'],
        github: '',
      },
      {
        title: 'Portfolio Website',
        description: ["Created a website to showcase my projects and experience", "Designed a responsive UI using React and Material-UI", "Implemented a particle.js background to add a unique visual element to the website"],
        technologies: ['JavaScript', 'React', 'HTML', 'CSS', 'Firebase'],
        github: '',
      },
    ];

    (async () => {
        await loadPolygonPath(tsParticles);
      
        await tsParticles.load({
          particles: {
            color: {
              value: "#FF0000",
              animation: {
                enable: true,
                speed: 10
              }
            },
            move: {
              attract: {
                enable: false,
                distance: 100,
                rotate: {
                  x: 2000,
                  y: 2000
                }
              },
              direction: "none",
              enable: true,
              outModes: {
                default: "destroy"
              },
              path: {
                clamp: false,
                enable: true,
                delay: {
                  value: 0
                },
                generator: "polygonPathGenerator",
                options: {
                  sides: 6,
                  turnSteps: 30,
                  angle: 30
                }
              },
              random: false,
              speed: 2,
              straight: false,
              trail: {
                fillColor: "#000",
                length: 20,
                enable: true
              }
            },
            number: {
              density: {
                enable: true,
                area: 800
              },
              value: 0
            },
            opacity: {
              value: 1
            },
            shape: {
              type: "circle"
            },
            size: {
              value: 2
            }
          },
          background: {
            color: "#000"
          },
          fullScreen: {
            zIndex: -1
          },
          emitters: {
            direction: "none",
            rate: {
              quantity: 1,
              delay: 1
            },
            size: {
              width: 0,
              height: 0
            },
            position: {
              x: 50,
              y: 50
            }
          }
        });
      })();


      return (
        <div className="Projects">
          <Box className="header">
            <Typography variant="h3" sx={{ fontFamily: 'Amiri' }}>Projects</Typography>
          </Box>
          <Box className="project-list">
            {projectList.map((project, index) => (
              <Card className="project-card" key={index}>
                <CardContent className="project-card-content">
                  <Typography sx={{ fontFamily: 'Amiri', fontSize: 22, color: '#173A5E', fontWeight: 'bold' }}>
                    {project.title}
                  </Typography>
                  <Typography sx={{ fontFamily: 'Amiri', fontSize: 18, color: '#173A5E' }}>
                    {project.description.map((point, i) => (
                      <ul key={i}>
                        <li>
                          {point}
                        </li>
                      </ul>
                    ))}
                  </Typography>
                  <Typography sx={{ fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', fontStyle: 'italic', marginTop: '0.5rem' }}>
                    Technologies: {project.technologies.join(', ')}
                  </Typography>
                  <Typography sx={{ fontFamily: 'Amiri', fontSize: 16, color: '#173A5E', fontStyle: 'italic', marginTop: '0.5rem' }}>
                    {project.github}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </div>
      );
};

export default Projects